import React from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'

const headerLevels = {
  1: {
    size: 70,
    mobile: 40
  },
  2: { size: 50, mobile: 25 },
  3: {
    size: 35,
    mobile: 25
  },
  4: {
    size: 20,
    mobile: 20
  },
  5: {
    size: 18,
    mobile: 18
  },
  6: {
    size: 14,
    mobile: 14
  }
}
const Style = styled.div`
z-index: 1000;
max-width: none;
min-width: 100%;
  display: ${(props) => (props.inline ? 'inline-block' : 'block')};
  & > * {
		${(props) =>
      props.spaced
        ? css`
            letter-spacing: 2px;
          `
        : ''}
    text-transform: ${(props) =>
      props.allCaps ? 'uppercase' : props.capitalize ? 'capitalize' : null};
    color: #171717;
  ${(props) =>
    props.color
      ? css`
          color: ${(props) => props.theme[props.color]};
        `
      : ''};
    font-size: ${(props) => headerLevels[props.display].size}px;
		@media(max-width: 600px) {
			font-size: ${(props) => headerLevels[props.display].mobile}px;
		}
    font-weight: ${(props) => (props.light ? 400 : props.normal ? 400 : 600)};
    text-align: ${(props) => props.align};
    margin-bottom: 0px;
    margin-top: 0px;

    ${(props) =>
      props.display == 1
        ? css`
            line-height: 50px;
            margin-bottom: 10px;
          `
        : ''} ::selection {
      background: #cbbaae;
    }
    ${(props) =>
      props.testimonial == 1
        ? css`
            margin-bottom: 40px;
            font-size: 40px;
          `
        : ''} 
    }
  }
`

const Header = ({
  capitalize,
  as,
  display,
  color,
  align,
  children,
  light,
  allCaps,
  inline,
  condensed,
  spaced,
  testimonial,
  style,
  className,
  normal,
  ...rest
}) => {
  const Tag = as
  return (
    <Style
      style={style}
      spaced={spaced}
      condensed={condensed}
      testimonial={testimonial}
      inline={inline}
      allCaps={allCaps}
      align={align}
      light={light}
      color={color}
      display={display}
      normal={normal}
      {...rest}
    >
      <Tag
        className={className}
        style={style}
      >
        {children}
      </Tag>
    </Style>
  )
}

Header.propTypes = {
  as: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'p']),
  display: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  children: PropTypes.element.isRequired,
  allCaps: PropTypes.bool,
  capitalize: PropTypes.bool,
  color: PropTypes.oneOf([
    'white',
    'black',
    'charcoal',
    'darkGray',
    'lightGray',
    'gray',
    'medGray',
    'test',
    'orange',
    'tan',
    'blue'
  ]),
  align: PropTypes.string,
  light: PropTypes.bool,
  inline: PropTypes.bool,
  condensed: PropTypes.bool,
  spaced: PropTypes.bool,
  testimonial: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
  normal: PropTypes.bool,
  theme: PropTypes.object
}

Header.defaultProps = {
  as: 'h1',
  display: 1,
  align: 'center',
  allCaps: false,
  capitalize: false
}

export default Header
